import protectedAxios from "../axios";
import { API_URL } from "../constants";
import * as Sentry from "@sentry/react";

export default async function apiCall(
  method,
  endpoint = "",
  data = null,
  params = null,
  version = "v1"
) {
  try {
    const config = {
      method,
      url: `${API_URL}/${version}/${endpoint}`,
      ...(data && { data }),
      ...(params && { params }),
    };

    const response = await protectedAxios(config);
    return response.data;
  } catch (error) {
    // Don't report 404 to Sentry - expected for deactivated/deleted content
    // (banned profiles, removed Q&A, deactivated gigs, deleted conversations, etc.)
    const isExpected404 =
      error?.status === 404 || error?.response?.status === 404;

    if (!isExpected404) {
      // Log the error to Sentry with additional context
      Sentry.withScope((scope) => {
        scope.setExtra("method", method);
        scope.setExtra("endpoint", endpoint);
        scope.setExtra("requestData", data);
        scope.setExtra("requestParams", params);
        scope.setExtra("errorResponse", error.response?.data);
        Sentry.captureException(error);
      });
    }
    throw error;
  }
}
